import merchantCtor from "./utils/merchantCtor";
import {displayDateDetailedMerchant, displayDateTimeMerchant} from "./utils/displayDateTime";
import {displayAmountMerchant} from "./utils/displayAmountData";
import toEllipsisMiddle from "../../../../utils/toEllipsisMiddle";

const ellipsisMiddleFn = (val) => toEllipsisMiddle(val, 16);

const displayDataMerchantDefault = merchantCtor();
const displayDataMerchantEllipsed = merchantCtor({dataHandler: ellipsisMiddleFn});

export const DisplayDataMerchant = displayDataMerchantDefault;
export const DisplayIdMerchant = displayDataMerchantEllipsed;
export const DisplayAddressMerchant = displayDataMerchantEllipsed;

export const DisplayDateTimeMerchant = displayDateTimeMerchant;
export const DisplayDateDetailedMerchant = displayDateDetailedMerchant;

export const DisplayAmountMerchant = displayAmountMerchant;

export {
  DisplayAmountFCMerchant
} from './components/DisplayAmountFC';
